import React from "react";

import './EditAlertPriorityModal.scss'
import {ADD, useToastContext} from "../../Toast";
import {useRecoilState, useRecoilValue} from "recoil";
import {
  editAlarmPriorityModalOpenState,
  editAlarmPriorityModalPriorityState,
  selectedAlarmState
} from "../../../state/alerts_table";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import {Modal, Select, SelectItem,} from "@carbon/react";

const EditAlertPriorityModal = () => {
  const { toastDispatch } = useToastContext();
  const [selectedAlarm, setSelectedAlarm] = useRecoilState(selectedAlarmState)
  const [editAlarmPriorityModalOpen, setEditAlarmPriorityOpen]  = useRecoilState(editAlarmPriorityModalOpenState)
  const [alarmPriorityModalPriority, setAlarmPriorityModalPriorityState]  = useRecoilState(editAlarmPriorityModalPriorityState)
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  return (
    <Modal
      open={editAlarmPriorityModalOpen}
      modalHeading="Modifica la priorità dell'allarme "
      modalLabel="Dati allarme"
      primaryButtonText="Salva"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        const req = new proto.api.UpdateAlarmRequest()
        let alarm = new proto.api.Alarm()
        alarm.setId(selectedAlarm.id)
        alarm.setSeverity(alarmPriorityModalPriority)
        req.setAlarm(alarm)
        alarmsService.updateAlarm(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile modificare la priorità. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione avvenuta con successo",
                content: "Priorità allarme '" + selectedAlarm.id +  "' modificata con successo",
                kind: "success"
              }
            })
            setEditAlarmPriorityOpen(false)
          }
        })
      }}
      onRequestClose={() => {
        setEditAlarmPriorityOpen(false)
      }}>
      <p style={{marginBottom: 'rem'}}>
        Questa interfaccia ti consente di modificare la priorità (o severità) dell'allarme. La priorità influisce
        sull'ordinamento dell'allarme sulla lista presente in dashboard. Modificando questo valore, il record in modifica
        potrebbe subire un cambiamento sulla visibilità nella lista appena citata.
      </p>
      <br/>
      <Select
        id="alarm-priority"
        labelText="Priorità allarme"
        data-modal-primary-focus
        value={alarmPriorityModalPriority}
        onChange={ev => {
          setAlarmPriorityModalPriorityState(ev.target.value)
        }}
        style={{marginBottom: 'rem'}}>
        <SelectItem text="Grave" value="Grave" />
        <SelectItem text="Lieve" value="Lieve" />
        <SelectItem text="Informativo" value="Informativo" />
      </Select>
    </Modal>
  );
}

export default EditAlertPriorityModal